import styled, { css } from "styled-components";
import { borderRadius, color, snap, typeStyle, units, variant } from "@m/alchemy-theme";
const alertBorderRadiusStyles = variant("attached", {
    top: `${borderRadius("large")} ${borderRadius("large")} 0 0`,
    bottom: `0 0 ${borderRadius("large")} ${borderRadius("large")}`,
    none: `${borderRadius("large")}`
});
export const Alert = styled.div `
  overflow: hidden;
  display: flex;
  align-items: center;
  min-width: ${snap(89)};
  padding: ${({ size }) => (size === "extraSmall" ? units(0.5) : size === "small" ? units(0.75) : units(1))};
  ${typeStyle("subHeaderS")};
  word-break: ${({ shouldWrapContent }) => (shouldWrapContent ? "break-word" : "inherit")};
  white-space: ${({ shouldWrapContent }) => (shouldWrapContent ? "normal" : "inherit")};

  background-color: ${color("hint")};
  border-radius: ${alertBorderRadiusStyles};
`;
export const AlertIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: ${({ size }) => (size === "extraSmall" ? units(2) : size === "small" ? units(2.25) : units(3))};
  width: 100%;
  max-width: ${({ size }) => (size === "extraSmall" ? units(2) : size === "small" ? units(2.25) : units(3))};
  background-color: ${color("base")};
  border-radius: 50%;

  svg {
    color: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? color("inverse") : color("container"))};
  }
`;
export const AlertText = styled.div `
  display: flex;
  flex-shrink: 0;
  flex-grow: 1;
  align-items: center;
  padding-left: ${units(1.5)};
  color: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? color("contrast") : color("typeBody"))};
  text-align: left;
  width: ${({ size }) => (size === "small" || size === "extraSmall" ? "100%" : "50%")};
  ${({ size }) => size === "extraSmall" &&
    css `
      margin-left: ${units(1)};
    `}
`;
export const AlertStatus = styled.div `
  padding-left: ${units(1)};
  padding-right: ${units(1.5)};
  text-transform: uppercase;

  ${(props) => (props.size === "small" || props.size === "extraSmall" ? typeStyle("captionM") : typeStyle("labelM"))}
  ${({ size }) => size === "extraSmall" && "display: flex;"}

  color: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? color("contrast") : color("typeBody"))};
  font-weight: bold;
  line-height: 1.4;

  ${AlertText} {
    padding-left: 0;
    font-weight: normal;
    text-transform: none;
    width: 100%;
  }
`;
